// frontend/src/utils/assessmentstatusEnum.js
// enrollment assessment status enumeration
const assessmentStatusEnum = Object.freeze({
  PENDING: "pending",
  PASS: "pass",
  FAIL: "fail",
  SPECIAL_CHANCE: "special-chance",
}); 
export default assessmentStatusEnum;